<template>
  <div :style="{ width: isIe }">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="socoton视屏教程" name="first">
        <Vidoe :list="socotonData" @detail="socotonDetail" ref="socotonRef"></Vidoe>
      </el-tab-pane>
      <el-tab-pane label="leartoo视屏教程" name="second">
        <Vidoe :list="leartoo" @detail="leartooDetail" ref="leartooRef"></Vidoe>
      </el-tab-pane>
      <el-tab-pane label="操作手册" name="third">
        <el-card class="box-card">
          <div v-for="item in download" :key="item.id" class="text item">
            <div class="look">
              <img src="../../../assets/app_img/icon_ppt.png" alt="" />
              <a target="view_window" :href="item.url">{{ item.name }}</a>
            </div>
          </div>
        </el-card>
      </el-tab-pane>
    </el-tabs>

    <!-- 视频对话框 -->
    <!-- <Dialog></Dialog> -->
    <el-dialog :visible.sync="dialogVisible" width="70%" top="55px" @close="closeDlg">
      <iframe class="page-img" :src="socotonimg" allow="autoplay" frameborder="0" allowfullscreen="true"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import { instance } from "../../../components/axios/auth"
import Vidoe from "./vidoe"
import Dialog from "./dialog"
export default {
  components: { Vidoe, instance, Dialog },
  data () {
    return {
      dialogVisible: false,
      activeName: "first",
      socotonData: [],
      leartoo: [],
      download: [],
      player2: null,
      article: null,
      socotonimg: "",
      leartooimg: "",
      url: '',
      isIe: '',
    }
  },
  created () { },
  mounted () {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      this.isIe = '1677px'
    } else {
      this.isIe = '100%'
    }
    this.socoton_data()
    this.getdata()
  },
  methods: {
    closeDlg () {
      this.socotonimg = null
    },
    getdata () {
      let str = 'http://easydss.socoton.com/fvod/jiaocheng/COj0tPqGR/video.m3u8'
      str.split('/fvod')
      let arr = str.split('/fvod')
      this.url = arr[0] + '/easyplayer.html?videoUrl=' + str + '&type=vod"'
    },
    handleClick (tab, event) {
    },
    async socoton_data () {
      const res = await this.$axios.post("/base/manual/index", {})
      if (res.data.errCode == 0) {
        let data = res.data.data
        for (let i = 0; i < data.socoton.length; i++) {
          data.socoton[i].url = data.socoton[i].url.split('/fvod')[0] + '/easyplayer.html?videoUrl=' + data.socoton[i].url + '&type=vod'
        }
        for (let i = 0; i < data.leartoo.length; i++) {
          data.leartoo[i].url = data.leartoo[i].url.split('/fvod')[0] + '/easyplayer.html?videoUrl=' + data.leartoo[i].url + '&type=vod'
        }
        this.socotonData = data.socoton
        this.leartoo = data.leartoo
        this.download = data.text
      }
    },
    socotonDetail (row) {
      this.socotonimg = row.item.url
      this.dialogVisible = true
    },
    leartooDetail (row) {
      this.socotonimg = row.item.url
      this.dialogVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>
.iframe {
  width: 500px;
}

.look {
  display: flex;
  justify-items: center;

  >a {
    line-height: 30px;
    margin-left: 30px;
  }

  >a:hover {
    cursor: pointer;
  }

  img {
    width: 30px;
    height: 30px;
  }
}

/deep/ .el-tabs__nav-wrap::after {
  // background-color:red;
  // display: none;
}

/deep/ .el-menu--horizontal>.el-menu-item {
  width: 50%;
  border-bottom: none;
  height: 1rem;
  line-height: 0.5rem;
  text-align: center;
}

/deep/ .el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: none;
}

/deep/ .el-tabs__nav-scroll {
  padding: 15px 0;
  border-bottom: 0px solid #ccc;
}

el-tabs {
  color: #1b2422;
  font-weight: bolder;
}

/deep/ .el-dialog__header {
  border-bottom: none;
}

/deep/ .el-dialog {
  // background: red;
}

.page-img {
  width: 100%;
  // height: 100%;
  height: 770px;
}</style>



// WEBPACK FOOTER //
// src/view/Panel/caozuoshouce/index.vue